// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Clickable from "@insite/mobius/Clickable";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link/Link";
import TextField from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import Button from "@store/MobiusOverrides/Button/Button";
import openPartFinderDrawer from "@store/Framework/Store/Store/Components/PartFinder/Handlers/OpenPartFinderDrawer";
import { PackageModel, PartModel } from "@store/Framework/Types/ApiModels";
import { PartFinderListStyles } from "@store/Library/Components/PartFinder/PartFinderListItem";
import ProductAvailabilityWithPickup from "@store/Library/Components/ProductAvailabilityWithPickup";
import SupersededByComponent from "@store/Library/Components/ProductDetails/SupersededBy";
import ProductPrice from "@store/Overrides/Components/ProductPrice";
import parse from "html-react-parser";
import React, { ChangeEvent } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    contextData?: ProductContextModel;
    styles: PartFinderListStyles;
    packageModel?: PackageModel;
    part: PartModel;
    keyPressHandler: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    openModalHandler: (productQty: string, product: ProductModel, part: PartModel) => void;
    replacements?: PartModel[];
    hideDrawerActions?: boolean;
    isKit?: boolean;
    qtyReplacementsChangeHandler?: (
        event: ChangeEvent<HTMLInputElement>,
        packageModel: PartModel[] | undefined,
        partId: string | undefined,
    ) => void;
    setOrderQty: (value: React.SetStateAction<string>) => void;
    orderQty: string;
    isLoading: boolean;
    addToCartHandler: (productContext: ProductContextModel, productQty: string) => Promise<void>;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        isAddingProductToCart: state.store.components.partFinder.isAddingProductToCart,
    };
};

const mapDispatchToProps = {
    openPartFinderDrawer,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const PartFinderListItemProductLine: React.FC<Props> = ({
    contextData,
    openPartFinderDrawer,
    styles,
    packageModel,
    part,
    keyPressHandler,
    openModalHandler,
    replacements,
    hideDrawerActions,
    isKit,
    qtyReplacementsChangeHandler,
    setOrderQty,
    orderQty,
    isAddingProductToCart,
    isLoading,
    addToCartHandler,
}) => {
    const productContext = React.useContext(ProductContext);
    const product = productContext.product;
    const img = <Img {...styles.img} loading="lazy" width="100" height="100" src={part.imageUrl} altText={part.name} />;
    const partName = <Typography {...styles.partName}>{parse(part?.name || "", parserOptions)}</Typography>;
    const isCatalogProduct = part?.url && part.url.length > 0;
    const wrapperStyle = isKit ? styles.partFinderListKitItemWrapper : styles.partFinderListItemWrapper;
    const isObsolete = !!(
        product &&
        product.properties?.isObsolete &&
        product.properties?.isObsolete?.toLowerCase() === "true"
    );
    const isSupersededBy = product && product.properties.supersededBy;
    return (
        <StyledWrapper {...wrapperStyle}>
            {part.itemNumber !== undefined && part.hasDrawing && (
                <Typography {...styles.itemNumber}>{part.itemNumber}</Typography>
            )}
            <GridContainer {...styles.partContainer}>
                <GridItem {...styles.partImageGridItem}>
                    {isCatalogProduct ? (
                        <Clickable
                            {...styles.linkWrappingImage}
                            onClick={() => openModalHandler(orderQty, product, part)}
                            data-test-selector="productImage"
                        >
                            {img}
                        </Clickable>
                    ) : (
                        img
                    )}
                </GridItem>
                <GridItem {...styles.partDescriptionGridItem}>
                    {(part.hasDrawing || part.hasSvg || !hideDrawerActions) && (
                        <Link
                            {...styles.viewDiagramMobile}
                            onClick={() =>
                                openPartFinderDrawer({
                                    part,
                                    tab: "schemaview",
                                })
                            }
                        >
                            {translate("View Diagram")}
                        </Link>
                    )}
                    <StyledWrapper {...styles.partDescription}>
                        <StyledWrapper as="p">
                            <Typography {...styles.partNumber}>
                                {translate("MFR #")}
                                {part?.number}
                            </Typography>
                            {part.isCritical && (
                                <Typography {...styles.criticalPart}>
                                    <Icon {...styles.criticalIcon} />
                                    {translate("Critical Part")}
                                </Typography>
                            )}
                        </StyledWrapper>
                        <StyledWrapper {...styles.partTitle}>
                            {part.kitModels && part.kitModels.length > 0 && (
                                <Typography {...styles.kit}>{translate("Kit")}</Typography>
                            )}
                            {isCatalogProduct ? (
                                <Clickable
                                    {...styles.linkPartName}
                                    onClick={() => openModalHandler(orderQty, product, part)}
                                >
                                    {partName}
                                </Clickable>
                            ) : (
                                partName
                            )}
                        </StyledWrapper>
                        {part?.quantity && (
                            <Typography {...styles.partQtyInUnit}>{`${translate("Qty in Unit:")} ${
                                part?.quantity
                            }`}</Typography>
                        )}
                    </StyledWrapper>
                    <StyledWrapper {...styles.partAvailabilityReplacement}>
                        {part.availabilityStatus && (
                            <StyledWrapper {...styles.partAvailability}>
                                {!isObsolete && !isSupersededBy && (
                                    <ProductAvailabilityWithPickup
                                        isProductDetailsPage={false}
                                        isScratchAndDent={product?.properties?.isScratchAndDent}
                                        dcneAvailability={product?.properties?.availabilityStatus}
                                        canAddToCart={product?.canAddToCart}
                                    />
                                )}
                            </StyledWrapper>
                        )}
                        {(part.isSuperseded || part.hasHistory) && !hideDrawerActions && (
                            <Link
                                {...styles.viewReplacement}
                                onClick={() =>
                                    openPartFinderDrawer({
                                        part,
                                        tab: "replacementparts",
                                    })
                                }
                            >
                                {translate("View Replacement")}
                            </Link>
                        )}
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.partQtyPriceActionsGridItem}>
                    {isCatalogProduct && !isObsolete && !isSupersededBy && (
                        <GridContainer {...styles.partQtyPriceActionsGridItemContainer}>
                            <GridItem {...styles.qtyPriceGridItem}>
                                <StyledWrapper {...styles.qtyPrice}>
                                    {productContext && (
                                        <ProductPrice
                                            overridedStyles={styles.productPriceStyles}
                                            product={productContext}
                                            showSavings={true}
                                        />
                                    )}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.qtyPriceGridItem}>
                                <StyledWrapper {...styles.qtyPrice}>
                                    <TextField
                                        label={translate("QTY")}
                                        value={orderQty}
                                        type="number"
                                        min={0}
                                        max={999999}
                                        onKeyPress={keyPressHandler}
                                        onChange={event => {
                                            if (replacements && qtyReplacementsChangeHandler) {
                                                qtyReplacementsChangeHandler(event, replacements, part.id); // Tracks the QTY when the drawer is closed/reopened
                                            }
                                            setOrderQty(event.target.value.toString());
                                        }}
                                        {...styles.productQtyFormField}
                                    />
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    )}
                    <StyledWrapper {...styles.actions}>
                        {(part.hasDrawing || part.hasSvg) && !hideDrawerActions && (
                            <Link
                                {...styles.viewDiagram}
                                onClick={() =>
                                    openPartFinderDrawer({
                                        part,
                                        tab: "schemaview",
                                    })
                                }
                            >
                                {translate("View Diagram")}
                            </Link>
                        )}
                        {isCatalogProduct && !isObsolete && !isSupersededBy && (
                            <Button
                                {...styles.addToCartButton}
                                disabled={isAddingProductToCart}
                                isLoading={isLoading}
                                onClick={() => addToCartHandler(productContext, orderQty)}
                            >
                                {translate("Add to Cart")}
                            </Button>
                        )}
                        {isCatalogProduct &&
                            isObsolete && ( // Store Custom Code
                                <StyledWrapper {...styles.obsoleteWrapper}>
                                    <Typography data-test-selector="productDetails_obsoleteWarning">
                                        <span>{translate("Store_ProductDetail_Obsolete_Warning")}</span>
                                    </Typography>
                                </StyledWrapper>
                            )}
                        {product && isCatalogProduct && isSupersededBy && (
                            <StyledWrapper {...styles.supersededWrapper}>
                                <SupersededByComponent product={product} />
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PartFinderListItemProductLine);
